module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('strong', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226217062_05_pt1#pt1"
    }
  }, [_c('strong', [_vm._v("Part 1. Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226217062_06_ch1#ch1"
    }
  }, [_vm._v("1. The Economic Approach to Human Behavior")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226217062_07_pt2#pt2"
    }
  }, [_c('strong', [_vm._v("Part 2. Price and Prejudice")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226217062_08_ch2#ch2"
    }
  }, [_vm._v("2. Effective Discrimination")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226217062_09_pt3#pt3"
    }
  }, [_c('strong', [_vm._v("Part 3. Law and Politics")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226217062_10_ch3#ch3"
    }
  }, [_vm._v("3. Competition and Democracy")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226217062_11_ch4#ch4"
    }
  }, [_vm._v("4. Crime and Punishment: An Economic Approach")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226217062_12_pt4#pt4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Part 4. Time and Household Production")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226217062_13_ch5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. A Theory of the Allocation of Time")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226217062_14_ch6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The Allocation of Time and Goods over Time")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226217062_15_ch7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. On the New Theory of Consumer Behavior ("), _c('em', [_vm._v("with Robert T. Michael")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226217062_16_pt5#pt5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Part 5. Irrational Behavior")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226217062_17_ch8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Irrational Behavior and Economic Theory")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226217062_18_pt6#pt6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Part 6. Marriage, Fertility, and the Family")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226217062_19_ch9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. An Economic Analysis of Fertility")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226217062_20_ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. On the Interaction between the Quantity and Quality of Children ("), _c('em', [_vm._v("with H. Gregg Lewis")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226217062_21_ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. A Theory of Marriage")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/9780226217062_22_pt7#pt7",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Part 7. Social Interactions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226217062_23_ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. A. Theory of Social Interactions")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226217062_24_ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Altruism, Egoism, and Genetic Fitness: Economics and Sociobiology")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226217062_25_not#not",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226217062_26_ref#ref",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("References")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226217062_27_ind#ind",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42250eda","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780226217062_04_toc.vue
// module id = 66
// module chunks = 0